import React from 'react';

import { IconWifiOff } from '@tabler/icons';

import { Container } from './styles';

const Offline: React.FC = () => {
  return (
    <Container>
      <div>
        <IconWifiOff size={100} color="#777" />
      </div>

      <h2>Sem conexão</h2>
      <p>Fique online para carregar esta página</p>
    </Container>
  );
};

export default Offline;
